import { render, staticRenderFns } from "./yuan-payment.vue?vue&type=template&id=8eda0422&scoped=true&"
import script from "./yuan-payment.vue?vue&type=script&lang=js&"
export * from "./yuan-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eda0422",
  null
  
)

export default component.exports